import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    navDrawerIsOpen?: boolean;
}>;

export const DispatchSetDesktopNavDrawerIsOpen: HandlerType = ({ dispatch, parameter: { navDrawerIsOpen } }) => {
    dispatch({
        type: "Components/DesktopDrawer/SetDesktopNavDrawerIsOpen",
        navDrawerIsOpen,
    } as any);
    if (navDrawerIsOpen === true) {

        dispatch({
            type: "Components/AddressDrawer/SetNavDrawerIsOpen",
            navDrawerIsOpen: false,
        } as any);
    }
};

export const chain = [DispatchSetDesktopNavDrawerIsOpen];

const setDesktopNavDrawerIsOpen = createHandlerChainRunner(chain, "SetDesktopNavDrawerIsOpen");
export default setDesktopNavDrawerIsOpen;
